var React = require('react');

function Assessment (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M14.2441 0.195068H1.75629C0.893849 0.195068 0.203117 0.893605 0.203117 1.75604L0.195312 15.8048L3.31726 12.6829H14.2441C15.1065 12.6829 15.8051 11.9843 15.8051 11.1219V1.75604C15.8051 0.893605 15.1065 0.195068 14.2441 0.195068ZM4.87824 9.56092H3.31726V7.99995H4.87824V9.56092ZM4.87824 7.21946H3.31726V5.65848H4.87824V7.21946ZM4.87824 4.878H3.31726V3.31702H4.87824V4.878ZM10.3417 9.56092H6.43921V7.99995H10.3417V9.56092ZM12.6831 7.21946H6.43921V5.65848H12.6831V7.21946ZM12.6831 4.878H6.43921V3.31702H12.6831V4.878Z","fill":"white"}));
}

Assessment.defaultProps = {"width":"16","height":"16","viewBox":"0 0 16 16","fill":"none"};

module.exports = Assessment;

Assessment.default = Assessment;
